
import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import {ProgressBarType} from './ProgressBarType'

function ProgressBar(props:  ProgressBarType) {
  const { progress} = props;
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress variant="determinate" value={progress} />
      </Box>
  );
}

export default ProgressBar;